<script setup>
import { computed } from 'vue'
import { useDetectDevice } from '@/composables/device'
import { TILE_CHARTS } from '@/components/dashboard/tile-charts'

const props = defineProps({
  tileId: { type: String, required: true },
  tileType: { type: String, required: true },
  filters: { type: Object, default: () => ({}) },
  tileName: { type: String, default: '' },
})
const emit = defineEmits(['edit'])

const { isMobile } = useDetectDevice()

const currentChart = computed(() => TILE_CHARTS[props.tileType] ?? null)
</script>

<template>
  <div class="fit" style="position: relative;">
    <q-btn
      v-if="isMobile"
      round
      flat
      dense
      size="xs"
      icon="mdi-cog-outline"
      color="grey-5"
      class="template-settings-btn"
      @mousedown.stop
      @click.stop="emit('edit')"
    />

    <component
      :is="currentChart"
      v-if="currentChart"
      :filters="filters"
      class="fit"
    />
  </div>
</template>

<style scoped>
.template-settings-btn {
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  z-index: 10;
  opacity: 0;
  transition: opacity 0.2s;
}
.fit:hover .template-settings-btn {
  opacity: 1;
}
</style>
